import './_capAskAira.scss';
export { default as askAiraReducer } from './reducer';
export { AIRA_REDUCER_DOMAIN } from './constants';

import RuleGenerationBot from './RuleGenerationBot';
import ContentGenerationBot from './ContentGenerationBot';
import DocumentationBot from './DocumentationBot';
import AnalyticsBot from './Genie';
import ConfigurationBot from './ConfigurationBot';
import DocumentationChatBot from './DocumentationChatBot';
import CapAiMediaGeneration from './CapAiMediaGeneration';
import RuleSummarizationBot from './RuleSummarizationBot';

export { default as ruleGenSaga } from './RuleGenerationBot/saga';
export { default as analyticsBotSaga } from './Genie/saga';
export { default as docChatBotSaga } from './DocumentationChatBot/saga';
export { default as mediaGenSaga } from './CapAiMediaGeneration/saga';
export { default as ruleSummarizationBotSaga } from './RuleSummarizationBot/saga';

export default {
  RuleGenerationBot,
  ContentGenerationBot,
  DocumentationBot,
  AnalyticsBot,
  ConfigurationBot,
  DocumentationChatBot,
  CapAiMediaGeneration,
  RuleSummarizationBot
};
